const isDev =
  typeof process !== "undefined" && process.env.NODE_ENV === "development";

function ts() {
  const d = new Date();
  const h = String(d.getHours()).padStart(2, "0");
  const m = String(d.getMinutes()).padStart(2, "0");
  const s = String(d.getSeconds()).padStart(2, "0");
  const ms = String(d.getMilliseconds()).padStart(3, "0");
  return `${h}:${m}:${s}.${ms}`;
}

function truncateEmail(email: string | undefined | null): string {
  if (!email) return "***";
  const at = email.indexOf("@");
  if (at <= 3) return email.slice(0, 1) + "***" + email.slice(at);
  return email.slice(0, 3) + "***" + email.slice(at);
}

type LogData = Record<string, unknown>;

function fmt(scope: string, action: string, msg: string, data?: LogData) {
  const prefix = `[${ts()}] [${scope}]`;
  if (data) return [`${prefix} [${action}] ${msg}`, data];
  return [`${prefix} [${action}] ${msg}`];
}

export function createLogger(scope: string) {
  const noop = () => {};

  if (!isDev) {
    return {
      debug: noop as (..._args: unknown[]) => void,
      info: noop as (..._args: unknown[]) => void,
      warn: noop as (..._args: unknown[]) => void,
      error: noop as (..._args: unknown[]) => void,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      time: (_action: string) => noop,
      truncateEmail,
    };
  }

  return {
    debug(action: string, msg: string, data?: LogData) {
      console.debug(...fmt(scope, action, msg, data));
    },
    info(action: string, msg: string, data?: LogData) {
      console.info(...fmt(scope, action, msg, data));
    },
    warn(action: string, msg: string, data?: LogData) {
      console.warn(...fmt(scope, action, msg, data));
    },
    error(action: string, msg: string, data?: LogData) {
      console.error(...fmt(scope, action, msg, data));
    },
    time(action: string): () => void {
      const start = performance.now();
      return () => {
        const ms = (performance.now() - start).toFixed(1);
        console.info(...fmt(scope, action, `completed in ${ms}ms`));
      };
    },
    truncateEmail,
  };
}

export const eventDetailLog = createLogger("EventDetail");
